<template>
  <div>
    <div class="primary--text">{{ $t('message_beacon_type') }}</div>
    <apexchart
      :key="chartKey"
      type="area"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: ['value'],
  data() {
    return {
      chartKey: 0,
      data: null,
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          categories: [
            '00:00',
            '01:00',
            '02:00',
            '03:00',
            '04:00',
            '05:00',
            '06:00',
            '07:00',
            '08:00',
            '09:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00'
          ]
        }
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.data = this.value
        this.transformDataRenderChart()
      },
      deep: true
    }
  },
  mounted() {
    this.data = this.value
    this.transformDataRenderChart()
  },
  methods: {
    getDataSeries(dataset) {
      let objData = {}
      Object.keys(dataset).forEach((item) => {
        const value = dataset[item]

        objData['non_friend'] = objData['non_friend'] || []
        objData['non_friend'].push(value.non_friend)

        objData['friend'] = objData['friend'] || []
        objData['friend'].push(value.friend)
      })

      const series = Object.keys(objData).map((key) => {
        return {
          name: key === 'non_friend' ? 'Banner' : 'Enter',
          data: objData[key]
        }
      })

      return series
    },
    transformDataRenderChart() {
      const vm = this
      try {
        const tempData = cloneDeep(vm.data)
        if (tempData) {
          const chartSeries = vm.getDataSeries(tempData)
          vm.series = chartSeries
        } else {
          vm.series = []
        }
        vm.chartKey += 1
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Analytics/Charts/MetricMessagesByTimeChart.vue